import { render, staticRenderFns } from "./CompanyCtepChangeNickname.vue?vue&type=template&id=53d90205&scoped=true&"
import script from "./CompanyCtepChangeNickname.vue?vue&type=script&lang=ts&"
export * from "./CompanyCtepChangeNickname.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d90205",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53d90205')) {
      api.createRecord('53d90205', component.options)
    } else {
      api.reload('53d90205', component.options)
    }
    module.hot.accept("./CompanyCtepChangeNickname.vue?vue&type=template&id=53d90205&scoped=true&", function () {
      api.rerender('53d90205', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyCtepChangeNickname.vue"
export default component.exports